/**
 * Drop-in shim for `@expo/vector-icons`.
 *
 * Rinsepay only imports `Ionicons` as a named export.  We re-export it
 * from `react-native-vector-icons/Ionicons`, but cast away the v10
 * strict-name typing so that `name="some-icon"` accepts arbitrary
 * strings (matching the looser @expo/vector-icons API the codebase was
 * built against) and `Ionicons.glyphMap` is exposed.
 *
 * If we ever migrate the codebase to literal-typed icon names, drop the
 * cast and let the strict types apply directly.
 */
import IoniconsImpl from 'react-native-vector-icons/Ionicons';
import MaterialIconsImpl from 'react-native-vector-icons/MaterialIcons';
import MaterialCommunityIconsImpl from 'react-native-vector-icons/MaterialCommunityIcons';
import FontAwesomeImpl from 'react-native-vector-icons/FontAwesome';
import FeatherImpl from 'react-native-vector-icons/Feather';
import AntDesignImpl from 'react-native-vector-icons/AntDesign';
import type { ComponentType } from 'react';
import type { TextStyle, StyleProp } from 'react-native';

interface LooseIconProps {
  name: string;
  size?: number;
  color?: string;
  style?: StyleProp<TextStyle>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [extra: string]: any;
}

type LooseIcon = ComponentType<LooseIconProps> & {
  glyphMap: Record<string, number>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [extra: string]: any;
};

export const Ionicons = IoniconsImpl as unknown as LooseIcon;
export const MaterialIcons = MaterialIconsImpl as unknown as LooseIcon;
export const MaterialCommunityIcons = MaterialCommunityIconsImpl as unknown as LooseIcon;
export const FontAwesome = FontAwesomeImpl as unknown as LooseIcon;
export const Feather = FeatherImpl as unknown as LooseIcon;
export const AntDesign = AntDesignImpl as unknown as LooseIcon;
